
import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import "jspdf/dist/polyfills.es.js"; 
import Select from "react-select";
// add these with your other imports
import JsBarcode from 'jsbarcode';
import ReactDOM from 'react-dom';



function OpdRegistrations() {
    const [ldata, setLdata] = useState(null);
    const [uhidSuggestions, setUhidSuggestions] = useState([]);
    const [isSaved, setIsSaved] = useState(false);
      const [specSearch, setSpecSearch] = useState("");
  const [docSearch, setDocSearch] = useState("");
  const [showSpecOptions, setShowSpecOptions] = useState(false);
  const [showDocOptions, setShowDocOptions] = useState(false);
const [filteredDoctors, setFilteredDoctors] = useState([]);
// Add these at the top of your OpdRegistrations component
const [headerLogo, setHeaderLogo] = useState('');
const [watermarkLogo, setWatermarkLogo] = useState('');
   const [footerImage, setFooterImage] = useState('');
   const [lastSavedPaid, setLastSavedPaid] = useState(''); // tracks paid amount at last successful save
   const [lastSavedDue, setLastSavedDue] = useState('');   // optional — tracks due at last save
   
   const [ageYears, setAgeYears] = useState('');
   const [ageMonths, setAgeMonths] = useState('');
   const [ageDays, setAgeDays] = useState('');
// Convert many backend date formats into a value usable by <input type="date">
const toDateInputValue = (val) => {
  if (!val) return '';
  // if already in YYYY-MM-DD form return as-is
  if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
  // try to parse with Date
  const t = new Date(val);
  if (isNaN(t.getTime())) return ''; // fallback empty
  return t.toISOString().split('T')[0];
};


   // near other refs at top of component
const barcodeCanvasRef = useRef(null);

// generate barcode PNG dataURL using an offscreen canvas (same approach as lab)
const generateBarcodeDataUrl = (value, options = {}) => {
  const canvas = barcodeCanvasRef.current || document.createElement('canvas');
  const v = (value && String(value).trim()) ? String(value).trim() : 'NA';
  try {
    JsBarcode(canvas, v, {
      format: options.format || 'CODE128',
      width: options.width || 2,
      height: options.height || 60,
      displayValue: options.displayValue === undefined ? false : options.displayValue,
      margin: options.margin || 5,
      textMargin: 0
    });
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Barcode generation failed', err);
    return null;
  }
};
// Print via hidden iframe (thermal-friendly)
const escapeHtml = (unsafe) => {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const printThermalBarcodeIframe = async (patientName, age, uhid) => {
  // 1) Generate barcode data URL
  const barcodeData = generateBarcodeDataUrl(uhid, { width: 2, height: 70, displayValue: false });

  // 2) build printable HTML
  const css = `
    <style>
      @media print {
        @page { size: 80mm auto; margin: 4mm; }
      }
      body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 6px;
        color: #000;
        width: 280px; /* ~80mm */
      }
      .ticket { text-align:center; padding:2px 4px; }
      .title { font-size:14px; font-weight:700; margin-bottom:6px; }
      .meta { font-size:12px; margin:2px 0; }
      .uhid { font-size:12px; font-weight:700; margin-top:6px; }
      .barcode { margin-top:8px; }
      img.barimg { max-width:100%; height:auto; }
      .small { font-size:10px; color:#333; margin-top:6px; }
    </style>
  `;

  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Print Barcode</title>${css}</head>
    <body>
      <div class="ticket">
        <div class="meta">Name: ${escapeHtml(patientName || 'N/A')}</div>
        <div class="meta">Age: ${escapeHtml(age || 'N/A')}</div>
        <div class="uhid">UHID: ${escapeHtml(uhid || 'N/A')}</div>
        <div class="barcode">${ barcodeData ? `<img class="barimg" src="${barcodeData}" alt="${escapeHtml(uhid)}"/>` : '<div style="height:60px">Barcode error</div>' }</div>
        <div class="small">Generated: ${new Date().toLocaleString()}</div>
      </div>
    </body></html>`;

  // 3) reuse or create hidden iframe
  const existing = document.getElementById('thermal-print-iframe');
  let iframe;
  if (existing) {
    iframe = existing;
    iframe.srcdoc = 'about:blank';
  } else {
    iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.id = 'thermal-print-iframe';
    document.body.appendChild(iframe);
  }

  return new Promise((resolve, reject) => {
    const onLoad = () => {
      try {
        const iwin = iframe.contentWindow;
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) {
          iwin.focus();
          iwin.print();
          resolve(true);
        } else {
          let loadedCount = 0;
          const checkDone = () => {
            loadedCount++;
            if (loadedCount >= imgs.length) {
              try {
                iwin.focus();
                iwin.print();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            }
          };
          for (let img of imgs) {
            if (img.complete) checkDone();
            else {
              img.addEventListener('load', checkDone);
              img.addEventListener('error', checkDone); // still proceed
            }
          }
        }
      } catch (err) {
        reject(err);
      }
    };

    if ('srcdoc' in iframe) {
      iframe.onload = onLoad;
      iframe.srcdoc = html;
    } else {
      iframe.onload = onLoad;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    }

    // safety timeout (resolve false if nothing prints)
    setTimeout(() => resolve(false), 8000);
  }).catch(err => {
    console.error('Print iframe error', err);
    return false;
  });
};

   // update numeric years in formData when years change (keeps backwards compatibility)
   const syncAgeToForm = (y, m, d) => {
     // y may be '' or a number string — ensure we store numeric years (or 0)
     const yearsNum = y === '' ? '' : String(Number(y) || 0);
     setFormData(prev => ({
       ...prev,
       opd_guardien_age: yearsNum
     }));
   };



   const formatDateTimeForReceipt = (isoOrDate) => {
    let d;
    if (!isoOrDate) {
        d = new Date();
    } else if (typeof isoOrDate === 'string') {
        // Handle "YYYY-MM-DD HH:MM:SS" format from database
        if (isoOrDate.includes(' ')) {
            const [datePart, timePart] = isoOrDate.split(' ');
            d = new Date(`${datePart}T${timePart}`);
        } else {
            d = new Date(isoOrDate);
        }
    } else {
        d = new Date(isoOrDate);
    }
    
    // If invalid date, use current time
    if (isNaN(d.getTime())) {
        d = new Date();
    }

    // ✅ ADD THIS RETURN STATEMENT
    // Day number with leading zero
    const dd = String(d.getDate()).padStart(2, '0');
    // Month short name
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();
  
    // 12-hour time
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) hours = 12;
    const hh = String(hours).padStart(2, '0');
  
    return `${dd}- ${mon}-${yyyy} ${hh}:${minutes} ${ampm}`;
};
  const getSpecialityName = (spec) => {
    if (spec === null || spec === undefined || spec === '') return '';
    if (typeof spec === 'string' && !/^\d+$/.test(spec)) return spec;
    const idStr = String(spec);
    const cats = Array.isArray(formData.cats) ? formData.cats : [];
    const found = cats.find(c =>
      String(c.cat_id ?? c.id ?? c.value ?? c.key ?? '').toLowerCase() === idStr.toLowerCase()
    );
    if (found) {
      return (found.cat_name ?? found.name ?? found.title ?? found.label ?? String(spec)).toString();
    }
    return String(spec);
  };
  const renderDesignationAndSpeciality = (doc = {}) => {
    const designation = (doc?.doc_designation ?? '').toString().trim();
    const specialityRaw = doc?.doc_specality ?? '';
    const speciality = getSpecialityName(specialityRaw).toString().trim();
    if (designation) return speciality ? `${designation} (${speciality})` : designation;
    return speciality;
  };
   // helper to produce a display string (e.g. "2Y 3M 5D")
   // format numeric age parts into "1 Year 2 Months 3 Days" (only includes non-zero parts)
const formatAgeFromParts = (years, months, days) => {
  // Accept numbers or numeric strings; treat '', null, undefined as 0
  const y = (years === '' || years === null || years === undefined) ? 0 : Number(years) || 0;
  const m = (months === '' || months === null || months === undefined) ? 0 : Number(months) || 0;
  const d = (days === '' || days === null || days === undefined) ? 0 : Number(days) || 0;

  const parts = [];
  if (y > 0) parts.push(`${y} ${y === 1 ? 'Year' : 'Years'}`);
  if (m > 0) parts.push(`${m} ${m === 1 ? 'Month' : 'Months'}`);
  if (d > 0) parts.push(`${d} ${d === 1 ? 'Day' : 'Days'}`);

  // If all parts zero, return empty string (so caller can fallback to 'N/A' or nothing)
  return parts.length ? parts.join(' ') : '';
};

// map speciality & doctor arrays to react-select-friendly options


// react-select handlers


  const specRef = useRef();
  const docRef = useRef();
     const [showOtherDetails, setShowOtherDetails] = useState(false);
    const [formData, setFormData] = useState({
        tests: [],
        vitals: [],
        cats:[],
        tests1: [
            {
                sn: 1,
                opd_val_name: '',
                opd_val_value: '',
            }
        ],
        comps: [
            {
                sn: 1,
                comp_name: ''
            }
        ],
        inspections: [  
            {
                sn: 1,
                insp_name: ''
            }
        ],

        docs: [],
        opd_token_no: '',
        opd_id: '',
        opd_uhid: '',
        opd_patient_title: 'Mr.',
        opd_patient_name: '',
        opd_patient_gender: 'Male',
        opd_patient_mobile: '',
        opd_guardien_age: '',
        opd_guardien_title: '',
        opd_guardien_name: '',
        opd_address: '',
        opd_city: '',
        opd_type: 'New Visit',
        opd_specality: '',
        opd_concult_doctor: '',
        opd_datetime: "",
        opd_total: '0',
        opd_fees: '0',
        opd_reg_fees: '0',
        opd_discount: '0',
        opd_final_amt: '0',
        opd_paid: '0',
        opd_mode: '',
        opd_remark: '',
        opd_due: '0',
        opd_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });



// ✅ Doctor ke hisaab se token nikalne ka function




    

// Modify your main useEffect
useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    
    // === MODIFIED PART: Set the next token automatically ===
    

    setFormData(prev => ({
        ...prev,
        opd_datetime: formattedDate,
        opd_token_no: '', // We add a new field in state for the token
    }));
    // ========================================================

    console.log('Component mounted');
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
        const parsed = JSON.parse(storedData);
        setLdata(parsed);
        initData(); // Your existing function
    }

    // ... your other logic for loading from sessionStorage
}, []);




useEffect(() => {
    let gtotal = 0.0;

    const fees = parseFloat(formData.opd_fees) || 0;
    const regFees = parseFloat(formData.opd_reg_fees) || 0;
    gtotal = fees + regFees;

    // Apply discount if any
    if (formData.opd_discount) {
        const dis = parseFloat(formData.opd_discount) || 0;
        gtotal = gtotal - (gtotal * dis) / 100;
    }

    const paid = parseFloat(formData.opd_paid) || 0;
    const due = gtotal - paid;

    setFormData(prev => ({
        ...prev,
        opd_total: (fees + regFees) + "",     // total before discount
        opd_final_amt: gtotal + "",           // after discount
        opd_due: due + "",                    // final due after payment
    }));
}, [formData.opd_fees, formData.opd_reg_fees, formData.opd_discount, formData.opd_paid]);



const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "opd_paid") {
        // Paid change -> update due immediately
        const paid = parseFloat(value) || 0;
        const fees = parseFloat(formData.opd_fees) || 0;
        const regFees = parseFloat(formData.opd_reg_fees) || 0;
        let gtotal = fees + regFees;
        if (formData.opd_discount) {
            const dis = parseFloat(formData.opd_discount) || 0;
            gtotal = gtotal - (gtotal * dis) / 100;
        }
        const due = gtotal - paid;

        setFormData(prev => ({
            ...prev,
            [name]: value,
            opd_due: due + "",
        }));
        return;
    }

    if (name === "opd_patient_title") {
        let gender = "";
        if (value === "Mr." || value === "Master") {
            gender = "Male";
        } else if (value === "Miss" || value === "Mr's") {
            gender = "Female";
        }
        setFormData(prev => ({
            ...prev,
            [name]: value,
            opd_patient_gender: gender,
        }));
        if (name === "search_key") {
            initData();
        }
        return;
    }



    setFormData(prev => ({
        ...prev,
        [name]: value,
    }));

      setIsSaved(false);
};





const handleSubmit = async (e) => {
  e.preventDefault();
  
  const fd = new FormData();

  var items = formData.tests1;
  for (var x = 0; x < items.length; x++) {
      const el1 = document.getElementById("vital45" + x);
      const el2 = document.getElementById("vitalval45" + x);
      items[x].opd_val_name = el1 ? el1.value : '';
      items[x].opd_val_value = el2 ? el2.value : '';
  }

  var items1 = formData.comps;
  for (var x = 0; x < items1.length; x++) {
      const el = document.getElementById("comp_txt" + x);
      items1[x].comp_name = el ? el.value : '';
  }

  var inspItems = formData.inspections;
  for (var x = 0; x < inspItems.length; x++) {
      const el = document.getElementById("insp_txt" + x);
      inspItems[x].insp_name = el ? el.value : '';
  }

  const buildCombinedAge = (y, m, d) => {
      const parts = [];
      if (y !== '' && Number(y) > 0) parts.push(`${Number(y)}Y`);
      if (m !== '' && Number(m) > 0) parts.push(`${Number(m)}M`);
      if (d !== '' && Number(d) > 0) parts.push(`${Number(d)}D`);
      return parts.length ? parts.join(' ') : (y ? String(Number(y)) : '');
  };    

  const combinedAge = buildCombinedAge(ageYears, ageMonths, ageDays);  
  
  // ✅ FIXED: Declare fullDateTime ONCE and update it with current time
  let fullDateTime = formData.opd_datetime;
  if (fullDateTime && fullDateTime.length >= 10) {
      const dateOnly = fullDateTime.split(' ')[0]; // Get date part (YYYY-MM-DD)
      
      // ✅ Get CURRENT time
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      fullDateTime = `${dateOnly} ${hours}:${minutes}:${seconds}`;
  }

  fd.append('opd_id', formData.opd_id);
  
  fd.append('opd_patient_title', formData.opd_patient_title);
  fd.append('opd_patient_name', formData.opd_patient_name);
  fd.append('opd_patient_gender', formData.opd_patient_gender);
  fd.append('opd_patient_mobile', formData.opd_patient_mobile);
  fd.append('opd_guardien_title', formData.opd_guardien_title);
  fd.append('opd_guardien_name', formData.opd_guardien_name);
  fd.append('opd_address', formData.opd_address);
  fd.append('opd_datetime', fullDateTime); // ✅ Uses the updated fullDateTime with current time
  fd.append('opd_guardien_age', combinedAge);
  fd.append('opd_guardien_years', ageYears === '' ? '' : ageYears);
  fd.append('opd_guardien_months', ageMonths === '' ? '' : ageMonths);
  fd.append('opd_guardien_days', ageDays === '' ? '' : ageDays);
  fd.append('opd_city', formData.opd_city);
  fd.append('opd_type', formData.opd_type);
  fd.append('opd_specality', formData.opd_specality);
  fd.append('opd_concult_doctor', formData.opd_concult_doctor);
  fd.append('opd_total', formData.opd_total);
  fd.append('opd_fees', formData.opd_fees);
  fd.append('opd_reg_fees', formData.opd_reg_fees);
  fd.append('opd_discount', formData.opd_discount);
  fd.append('opd_final_amt', formData.opd_final_amt);
  fd.append('opd_paid', formData.opd_paid);
  fd.append('opd_mode', formData.opd_mode);
  fd.append('opd_remark', formData.opd_remark);
  fd.append('opd_due', formData.opd_due);
  fd.append('opd_uhid', formData.opd_uhid);
  fd.append('opd_items', JSON.stringify(items) + "");
  fd.append('opd_comps', JSON.stringify(items1) + "");
  fd.append('opd_inspects', JSON.stringify(inspItems) + ""); 
  fd.append('opd_user', ldata.user_id);

  try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addOpdUrl, fd, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      });

      if (response.data.status) {
          const today = new Date().toISOString().split('T')[0];
          const storageKey = `token_${formData.opd_concult_doctor}_${today}`;
         
          
          const backendUHID = response.data.opd_dt.opd_uhid; 
          const backendID = response.data.opd_dt.opd_id; 
          const backendToken = response.data.opd_dt.opd_token_no;
          setFormData(prev => ({
              ...prev,
              opd_uhid: backendUHID || prev.opd_uhid,
              opd_id: backendID || prev.opd_id,
              opd_token_no: backendToken,
              opd_guardien_years: response.data.opd_dt.opd_guardien_years ?? prev.opd_guardien_years,
              opd_guardien_months: response.data.opd_dt.opd_guardien_months ?? prev.opd_guardien_months,
              opd_guardien_days: response.data.opd_dt.opd_guardien_days ?? prev.opd_guardien_days,
              opd_datetime: response.data.opd_dt.opd_datetime || prev.opd_datetime, // ✅ Keep full datetime
              opd_datetime_display: response.data.opd_dt.opd_datetime ? response.data.opd_dt.opd_datetime.split(' ')[0] : prev.opd_datetime_display, // ✅ Only date for display
              isAlert: true,
              alertMsg: response.data.success,
              alertMsgTyp: response.data.type,
          }));
          
          const savedPaid = response.data.opd_dt.opd_paid ?? formData.opd_paid ?? '0';
          const savedDue = response.data.opd_dt.opd_due ?? formData.opd_due ?? '0';
          setLastSavedPaid(String(Number(savedPaid || 0)));
          setLastSavedDue(String(Number(savedDue || 0)));
          setIsSaved(true);
          
          // ✅ Handle WhatsApp/SMS notification status
          if (response.data.whatsapp_status === 'sent') {
              toast.success('✅ Registration successful! SMS sent to patient.');
          } else if (response.data.whatsapp_status === 'failed') {
              toast.warning(`⚠️ Registration successful, but SMS failed: ${response.data.whatsapp_message}`);
          } else if (response.data.whatsapp_status === 'error') {
              toast.error(`❌ Registration successful, but SMS error: ${response.data.whatsapp_message}`);
          } else if (response.data.whatsapp_status === 'disabled') {
              toast.info('✓ Registration successful');
          } else {
              toast.success('✓ Registration Success');
          }
          
          if (response.data.whatsapp_details) {
              console.log('WhatsApp Details:', response.data.whatsapp_details);
          }
          
          sessionStorage.removeItem("opd_dt");
      }
      else {
          setFormData(prev => ({
              ...prev,
              isAlert: true,
              alertMsg: response.data.success,
              alertMsgTyp: response.data.type,
          }));
          toast.error('❌ Registration failed');
      }
  } catch (error) {
      console.error('Submit Error:', error);
      setFormData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: "Failed",
          alertMsgTyp: "danger",
      }));
      toast.error('❌ Server error occurred');
  }
};

const initData1 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);

             const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', "");
            fd2.append('page_no', "none");
            fd2.append('doc_specality', formData.opd_specality);
            fd2.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    }
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.tests1.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                tests1: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }


           

            const fd0 = new FormData();
            fd0.append('cat_type', "speciality");
            fd0.append('page_no', "none");
            fd0.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                });
                if (response.data.status) {

                var records = response.data.records;
                if (records != null && records != undefined) {
                    setFormData(prev => ({
                    ...prev,
                    cats: records
                    }));
                }
                }
            } catch (error) {

            }

            const fd00 = new FormData();
fd00.append('cat_type', "hospCharge");
fd00.append('cat_name', "Opd Fees");
fd00.append('page_no', "none");
fd00.append('par_by', 1 + "");

try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd00, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    
    if (response.data.status) {
        var records = response.data.records;
        
        if (records != null && records != undefined && records.length > 0) {
            // ✅ Filter for exact match instead of using records[1]
            const opdFeesRecord = records.find(record => 
                record.cat_name === "Opd Fees" || 
                record.cat_name.toLowerCase() === "opd fees"
            );
            
            if (opdFeesRecord) {
                setFormData(prev => ({
                    ...prev,
                    opd_reg_fees: opdFeesRecord.cat_type1
                }));
            } else {
                console.warn('OPD Fees record not found in response');
            }
        }
    }
} catch (error) {
    console.error('Error loading OPD Fees:', error);
}

              
        }
    };

    useEffect(() => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      const seconds = String(today.getSeconds()).padStart(2, '0');
      
      // Store as "YYYY-MM-DD HH:MM:SS" for backend, but display as date only
      const fullDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const formatted = `${year}-${month}-${day}`;
      const dateOnly = `${year}-${month}-${day}`;
      
      setFormData(prev => ({
          ...prev,
          opd_datetime: fullDateTime, // ✅ Store full datetime
          opd_datetime_display: dateOnly // ✅ For display in input field
      }));


        //console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {
// if (tmp.opd_concult_doctor) {
//                     updateTokenForDoctor(tmp.opd_concult_doctor);
//                 }


// populate numeric age inputs when editing existing record
const parsed = parseAgeString(tmp.opd_guardien_age, tmp.opd_guardien_years, tmp.opd_guardien_months, tmp.opd_guardien_days);
setAgeYears(parsed.y);
setAgeMonths(parsed.m);
setAgeDays(parsed.d);

                var items = tmp.items;
                var items1 = tmp.items1;

                setFormData(prev => ({
                    ...prev,
                    tests1: items,
                    comps: items1,
                    opd_id: tmp.opd_id,
                    opd_token_no: tmp.opd_token_no,
                    opd_patient_title: tmp.opd_patient_title,
                    opd_patient_name: tmp.opd_patient_name,
                    opd_patient_gender: tmp.opd_patient_gender,
                    opd_patient_mobile: tmp.opd_patient_mobile,
                    opd_guardien_title: tmp.opd_guardien_title,
                    opd_guardien_name: tmp.opd_guardien_name,
                    opd_address: tmp.opd_address,
                    opd_city: tmp.opd_city,
                    opd_type: tmp.opd_type,
                    opd_specality: tmp.opd_specality,
                    opd_concult_doctor: tmp.opd_concult_doctor,
                    opd_guardien_age: tmp.opd_guardien_age,
                    opd_total: tmp.opd_total,
                    opd_fees: tmp.opd_fees ? Number(tmp.opd_fees) : 0,
                    opd_reg_fees: tmp.opd_reg_fees ? Number(tmp.opd_reg_fees) : 0,
                    opd_discount: tmp.opd_discount ? Number(tmp.opd_discount) : 0,
                    opd_final_amt: tmp.opd_final_amt ? Number(tmp.opd_final_amt) : 0,
                    opd_paid: tmp.opd_paid ? Number(tmp.opd_paid) : 0,
                    opd_mode: tmp.opd_mode,
                    // opd_remark: tmp.opd_remark,
                     opd_due: tmp.opd_due ? Number(tmp.opd_due) : 0,
                    opd_user: tmp.opd_user,
                    opd_datetime: tmp.opd_datetime || prev.opd_datetime, // ✅ Keep full datetime from backend
                    opd_datetime_display: tmp.opd_datetime ? tmp.opd_datetime.split(' ')[0] : (prev.opd_datetime_display || formatted),

                }));
            }
        }



        return () => {
            //console.log('Component unmounted');
        };
    }, []);

      useEffect(() => {
        initData1();
    }, [formData.opd_specality]);

        // Add complaint row
    const addComplaint = () => {
        setFormData(prev => ({
            ...prev,
            comps: [
                ...prev.comps,
                {
                    sn: prev.comps.length + 1,
                    comp_name: ''
                }
            ]
        }));
    };

    // Remove complaint row
    const removeComplaint = (index) => {
        const newComps = [...formData.comps];
        newComps.splice(index, 1);
        setFormData(prev => ({
            ...prev,
            comps: newComps
        }));
    };

    // Add inspection row
    const addInspection = () => {
        setFormData(prev => ({
            ...prev,
            inspections: [
                ...prev.inspections,
                {
                    sn: prev.inspections.length + 1,
                    insp_name: ''
                }
            ]
        }));
    };

    // Remove inspection row
    const removeInspection = (index) => {
        const newInspections = [...formData.inspections];
        newInspections.splice(index, 1);
        setFormData(prev => ({
            ...prev,
            inspections: newInspections
        }));
    };

const searchUserNow = async (e) => {
  const uhid = e.target.value.trim();

  if (uhid.length < 3) { // thoda fast search ke liye 3 char ke baad call
    setUhidSuggestions([]);
    return;
  }

  try {
    const fd = new FormData();
    fd.append("lab_reg_uhid", uhid);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.searchUhidUrlCall,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status) {
      setUhidSuggestions(response.data.records || []);
    } else {
      setUhidSuggestions([]);
    }
  } catch (error) {
    console.error("Search Error:", error);
    setUhidSuggestions([]);
  }
};
const handleSelUser = async (lab_reg_dt) => {
  if (!lab_reg_dt) return;

  try {
    const fd = new FormData();
    fd.append("lab_reg_uhid", lab_reg_dt.lab_reg_uhid);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.searchUhidUrlCall,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status && response.data.records.length > 0) {
      const details = response.data.records[0];
  const {
  opd_guardien_age,
  opd_guardien_name,
  opd_patient_gender,
  opd_patient_name,
  opd_uhid
} = details;

//console.log(JSON.stringify(details));

setFormData(prev => ({
  ...prev,
  opd_type: 'Old',
  opd_guardien_age: opd_guardien_age || prev.opd_guardien_age || '',
  opd_uhid: opd_uhid || prev.opd_uhid || '',
  opd_guardien_name: opd_guardien_name || prev.opd_guardien_name || '',
  opd_patient_gender: opd_patient_gender || prev.opd_patient_gender || '',
  opd_patient_name: opd_patient_name || prev.opd_patient_name || ''
}));

    }

    toast.success("Data fetched successfully");
    setUhidSuggestions([]); // list close
  } catch (err) {
    //console.error("Error fetching user details:", err);
  }
};




     useEffect(() => {
    if (formData.opd_specality) {
      const filtered = formData.docs.filter(
        doc => doc.doc?.doc_specality === formData.opd_specality
      );
      setFilteredDoctors(filtered);
    } else {
      setFilteredDoctors(formData.docs);
    }
  }, [formData.opd_specality, formData.docs]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (specRef.current && !specRef.current.contains(event.target)) {
      setShowSpecOptions(false);
    }
    if (docRef.current && !docRef.current.contains(event.target)) {
      setShowDocOptions(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);



 // map speciality & doctor arrays to react-select-friendly options
 const specialityOptions = (formData.cats || []).map(c => ({ value: c.cat_id, label: c.cat_name }));
 const doctorOptions = (filteredDoctors || []).map(d => ({ value: d.user_id, label: d.fname || '' }));
// react-select handlers
const handleSpecSelect = (option) => {
  setFormData(prev => ({
    ...prev,
    opd_specality: option ? option.value : '',
    opd_concult_doctor: '', // clear doctor on speciality change
    opd_fees: '0'
  }));
};

// ✅ REPLACE with this
const handleDocSelect = (option) => {
  if (!option) {
    setFormData(prev => ({ 
      ...prev, 
      opd_concult_doctor: '', 
      opd_fees: '0',
      opd_token_no: '' // ✅ Just clear it - backend will assign
    }));
    return;
  }
  const docId = option.value;
  const selectedDoc = filteredDoctors.find(d => String(d.user_id) === String(docId)) || null;
  
  // ✅ NO token generation - backend handles it
  setFormData(prev => ({
    ...prev,
    opd_concult_doctor: docId,
    opd_fees: selectedDoc?.doc?.doc_fees || '0',
    // opd_token_no will be set by backend after save
  }));
};


// You can now delete the separate `updateTokenForDoctor` function, as its logic is now inside `handleDocSelect`.



useEffect(() => {
  if (formData?.opd_concult_doctor && filteredDoctors.length > 0) {
    const selectedDoc = filteredDoctors.find(
      doc => doc.user_id === formData.opd_concult_doctor
    );
    if (selectedDoc) {
      setDocSearch(selectedDoc.fname);
    }
  }
}, [formData.opd_concult_doctor, filteredDoctors]);


const isFormValid = () => {
  const requiredFields = [
    'opd_patient_name',
    'opd_specality',
    'opd_concult_doctor'
  ];

  return requiredFields.every(
    field =>
      formData[field] !== null &&
      formData[field] !== undefined &&
      String(formData[field]).trim() !== ''
  );
};

// console.log("this is formdata : " + JSON.stringify(formData))


// Modified fetchConfigData function
const fetchConfigData = async () => {
    try {
        const res = await axios.post(
            `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
        );
        if (res.data.status) {
          console.log(res.data)
            const data = res.data;
            // Use the new state setters
            setHeaderLogo( data.header_logo);
            setWatermarkLogo( data.logo || '');
            setFooterImage(data.footer_logo)
        }
    } catch (err) {
        console.error("Error fetching config:", err);
    }
};

// Modified useEffect to call it on component mount
useEffect(() => {
    fetchConfigData();
}, []); // Empty dependency array ensures it runs only once


const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
        const response = await fetch(url);
        if (!response.ok) return null;
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        //console.error("Error converting image to Base64:", error);
        return null;
    }
};
// Add this helper function inside your component
const numberToWords = (num) => {
    if (num === undefined || num === null || num === '') return '';

    num = Number(num); // convert to number
    if (isNaN(num)) return '';

    // Round to nearest integer (no paisa words)
    num = Math.round(num);

    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    if (num.toString().length > 9) return 'overflow';

    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';

    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';

    return str.charAt(0).toUpperCase() + str.slice(1).trim();
};

// simple parser for "23 Years 5 Months 10 Days" OR numeric parts from backend
const parseAgeString = (ageStr, yearsField, monthsField, daysField) => {
  // prefer explicit numeric fields if provided
  if (yearsField !== undefined || monthsField !== undefined || daysField !== undefined) {
    return {
      y: yearsField ? String(Number(yearsField)) : '',
      m: monthsField ? String(Number(monthsField)) : '',
      d: daysField ? String(Number(daysField)) : ''
    };
  }
  if (!ageStr) return { y: '', m: '', d: '' };
  const y = (ageStr.match(/(\d+)\s*(?:Year|Y)/i) || [])[1] || '';
  const m = (ageStr.match(/(\d+)\s*(?:Month|M)/i) || [])[1] || '';
  const d = (ageStr.match(/(\d+)\s*(?:Day|D)/i) || [])[1] || '';
  return { y: y ? String(Number(y)) : '', m: m ? String(Number(m)) : '', d: d ? String(Number(d)) : '' };
};



const generateInvoicePdf = async (invoiceData) => {
    if (!invoiceData) {
        toast.error("No invoice data available to generate PDF.");
        return;
    }

    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // ================= A. Load Images =================
    const headerImageBase64 = await imageUrlToBase64(invoiceData.config.headerLogoUrl);
    const watermarkImageBase64 = await imageUrlToBase64(invoiceData.config.watermarkLogoUrl);

    // ================= B. Header Logo Bar =================
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    // ================= C. Invoice Heading Box =================
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.rect(40, 90, pageWidth - 80, 25); // box
    doc.text("OPD Receipt", pageWidth / 2, 107, { align: 'center' });

    // ================= D. Patient & Bill Details =================
    const leftX = 50;
    const rightX = pageWidth / 2 + 20;
    let y = 140;

    const printDetail = (label, value, x, y) => {
        doc.setFont('helvetica', 'normal');
        doc.text(`${label} :`, x, y);
        doc.setFont('helvetica', 'normal');
        doc.text(`${value || ''}`, x + 85, y);
    };

    console.log(invoiceData)

    // Left side
    printDetail("UHID No", invoiceData.patient.uhid, leftX, y);
    printDetail("Patient Name", invoiceData.patient.name, leftX, y += 13);
    printDetail("Age/Sex", invoiceData.patient.ageSex, leftX, y += 13);
    printDetail("Patient Address", invoiceData.patient.address, leftX, y += 13);
    printDetail("Payment Method", invoiceData.payment.method, leftX, y += 13);

    // Right side
    y = 140;
    printDetail("Bill Date", invoiceData.bill.date, rightX, y);
    printDetail("Bill No", invoiceData.bill.no, rightX, y += 13);
    printDetail("Token No", invoiceData.bill.token, rightX, y += 13);
    printDetail("Receipt No", invoiceData.bill.receiptNo, rightX, y += 13);
    printDetail("Visit Date", invoiceData.bill.visitDate, rightX, y += 13);
    // printDetail("Opd No", invoiceData.bill.opdNo, rightX, y += 15);

    // ================= E. Transaction History =================
// ================= E. Transaction History Heading =================
// ===== Transaction History Heading =====
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(12);
// doc.text("Transaction History", 50, y + 10); // thoda upar ki taraf

// ===== Table =====
autoTable(doc, {
  startY: y + 15, // upar ka gap badha diya
  head: [['S.No', 'Doctor Name', 'Amount']],
  body: invoiceData.transactions.map(tx => [
      tx.sno || '',
      tx.description || '',
      tx.amount ? tx.amount.toFixed(2) : '0.00'
  ]),
  theme: 'grid',
  headStyles: {
      fillColor: [255, 255, 255], // white like screenshot
      textColor: 0,
      fontStyle: 'bold',
      lineWidth: 0.1,
      lineColor:0
  },
  styles: {
    fontSize: 10,
    cellPadding: 5,
    textColor: 0,
    lineColor: [0, 0, 0],        // body border black
  lineWidth: 0.3               // <-- ensures all body + table text is black
  },
  columnStyles: {
      0: { cellWidth: 40, halign: 'center' },
      1: { cellWidth: pageWidth - 200 },
      2: { cellWidth: 80, halign: 'right' }
  },
  margin: { left: 40, right: 40 }
});

let finalY = doc.lastAutoTable.finalY + 10; // niche ka gap bhi add kiya



    // ================= F. Charges Summary =================
    const labelX = pageWidth - 250;
    const colonX = pageWidth - 120;
    const valueX = pageWidth - 60;

    const printSummaryLine = (label, value) => {
        finalY += 18;
        doc.setFont('helvetica', 'normal');
        doc.text(label, labelX, finalY);
        doc.text(':', colonX, finalY);
        doc.setFont('helvetica', 'bold');
        doc.text(value, valueX, finalY, { align: 'right' });
    };

    printSummaryLine("Registration Charges", invoiceData.summary.regCharges.toFixed(2));
    printSummaryLine("Bill Amount (Round Off)", invoiceData.summary.billAmount.toFixed(2));
    printSummaryLine("Discount (%)", invoiceData.summary.discount.toFixed(0));
    printSummaryLine("Paid", invoiceData.summary.paid.toFixed(2));
    printSummaryLine("Due", invoiceData.summary.due.toFixed(2));

    // ================= G. Sum in Words =================
    finalY += 25;
    doc.setFont('helvetica', 'normal');
    doc.text(`Sum of Rs. ${invoiceData.summary.totalInWords} only Received`, 40, finalY);

    // ================= H. Watermark =================
    // if (watermarkImageBase64) {
    //     doc.setGState(new doc.GState({ opacity: 0.08 }));
    //     const wmSize = 300;
    //     doc.addImage(watermarkImageBase64, 'PNG',
    //         (pageWidth - wmSize) / 2,
    //         (pageHeight - wmSize) / 2,
    //         wmSize, wmSize
    //     );
    //     doc.setGState(new doc.GState({ opacity: 1 }));
    // }

    // ================= I. Signature =================
    // doc.text("Authorized Signature", pageWidth - 40, pageHeight - 80, { align: 'right' });
    // doc.text("SHRC ADMIN", pageWidth - 40, pageHeight - 65, { align: 'right' });

  
// ===== Full-width Footer Image =====
// const footerImgHeight = 40;
// doc.addImage(
//     footerImage,   // Base64 ya URL image variable
//     'PNG',       // format
//     0,           // X start (left edge)
//     pageHeight - footerImgHeight, // Y position (bottom se upar)
//     pageWidth,   // full page width
//     footerImgHeight // fixed height
// );


    // ================= K. Open PDF =================
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
};


const handlePrint = () => {
  const selectedDoctor = formData.docs.find(d => d.user_id === formData.opd_concult_doctor) || null;

  const doctorName = selectedDoctor ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim() : 'N/A';
  const docMeta = selectedDoctor?.doc || {};
  const doctorDesignationAndSpec = renderDesignationAndSpeciality(docMeta);
  const doctorSpeciality = getSpecialityName(docMeta?.doc_specality || docMeta?.doc_speciality || '');
  const doctorRegNo = (docMeta?.doc_reg_number || docMeta?.doc_reg_no || '').toString() || doctorSpeciality || 'N/A';
  const doctorDescription = doctorName === 'N/A'
    ? (doctorDesignationAndSpec || doctorSpeciality || 'N/A')
    : `${doctorName}${doctorDesignationAndSpec ? ' — ' + doctorDesignationAndSpec : ''}`;
  
  const token = formData.opd_token_no;
  const patientNameForReceipt = formData.opd_patient_name.replace(/ /g, '');
  const timeStamp = Date.now();

  const dynamicBillNo = `${timeStamp}-${token}`;
  const dynamicReceiptNo = `${patientNameForReceipt}-${token}`;
  
  // ✅ FIX: Get actual datetime from formData or use current time
  const actualDateTime = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
  
  const formattedAge = formatAgeFromParts(
    formData.opd_guardien_years ?? formData.opd_guardien_years, 
    formData.opd_guardien_months ?? formData.opd_guardien_months, 
    formData.opd_guardien_days ?? formData.opd_guardien_days
  );
  const ageDisplay = formattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
  
  const invoiceData = {
    config: { headerLogoUrl: headerLogo, watermarkLogoUrl: watermarkLogo },
    patient: {
      uhid: formData.opd_uhid || 'N/A',
      name: `${formData.opd_patient_title} ${formData.opd_patient_name}`.trim(),
      ageSex: `${ageDisplay} / ${formData.opd_patient_gender || 'N/A'}`,
      address: formData.opd_address || '',
    },
    payment: { method: formData.opd_mode },
    bill: {
      date: formattedDateTime,           // ✅ Same formatted time
      no: dynamicBillNo,
      token: token,
      receiptNo: dynamicReceiptNo,
      visitDate: formattedDateTime,      // ✅ Same formatted time
      opdNo: formData.opd_id || 'N/A',
    },
    transactions: [
      {
        sno: 1,
        description: `${doctorName}${selectedDoctor?.doc?.doc_degree ? ` (${selectedDoctor.doc.doc_degree})` : ''}${doctorSpeciality ? ` - ${doctorSpeciality}` : ''}`,
        amount: parseFloat(formData.opd_fees || 0)
      }
    ],
    summary: {
      regCharges: parseFloat(formData.opd_reg_fees || 0),
      billAmount: parseFloat(formData.opd_total || 0),
      discount: parseFloat(formData.opd_discount || 0),
      paid: parseFloat(formData.opd_paid || 0),
      due: parseFloat(formData.opd_due || 0),
      totalInWords: numberToWords(formData.opd_final_amt || 0)
    }
  };

  generateInvoicePdf(invoiceData);
};

const generatePrescriptionPdf = async (prescriptionData) => {
    if (!prescriptionData) {
        //console.error("No prescription data available to generate PDF.");
        return;
    }

    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;

    // ================= A. Header Logo =================
    const headerImageBase64 = await imageUrlToBase64(prescriptionData.config.headerLogoUrl);
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    // ================= B. Prescription Heading Box =================
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.setLineWidth(1.5);
    doc.rect(margin, 90, pageWidth - (margin * 2), 25);
    doc.text("OPD PRESCRIPTION", pageWidth / 2, 107, { align: 'center' });

    // ================= C. Patient & Visit Details =================
    let y = 135;
    const rowHeight = 18;
    const labelWidth = 65;

    const printDetail = (label, value, x, yPos) => {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(label, x, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(`:  ${value || ''}`, x + labelWidth, yPos);
    };

    const col1X = margin + 5;
    const col2X = margin + 220;
    const col3X = margin + 380;

    printDetail("UHID No", prescriptionData.patient.uhid, col1X, y);
    printDetail("OPD No", prescriptionData.bill.opdNo, col2X, y);
    printDetail("Date", prescriptionData.bill.date, col3X, y);
    y += rowHeight;

    printDetail("Name", prescriptionData.patient.name, col1X, y);
    printDetail("Age", prescriptionData.patient.age, col2X, y);
    printDetail("Sex", prescriptionData.patient.sex, col3X, y);
    y += rowHeight;

    printDetail("Address", prescriptionData.patient.address, col1X, y);
    printDetail("Mobile No", prescriptionData.patient.mobile, col2X, y);
    y += rowHeight;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("Doctor", col1X, y);
    doc.setFont('helvetica', 'normal');
    const doctorDetails = doc.splitTextToSize(`:  ${prescriptionData.doctor.name || ''} (${prescriptionData.doctor.degree}) (${prescriptionData.doctor.speciality})`, 600);
    doc.text(doctorDetails, col1X + labelWidth, y);
    printDetail("Doctor Reg No", prescriptionData.doctor.regNo, col3X, y);

     y += rowHeight; // thoda neeche line ke liye
    doc.setLineWidth(0.8);
    doc.line(0, y, pageWidth, y);   // Horizontal line full width

    // ================= D. Main Content Area =================
    let contentStartY = y + 30;
    const leftSectionWidth = 150;

    // Vertical divider (horizontal line se hi start karega)
    doc.setLineWidth(1.5);
    doc.line(leftSectionWidth, y, leftSectionWidth, pageHeight - margin - 20);


    // Horizontal dividers
    const historyY = contentStartY + 120;
    const adviceY = historyY + 260;
    doc.setLineWidth(0.5);
    doc.line(margin, historyY, leftSectionWidth, historyY);
    doc.line(margin, adviceY, leftSectionWidth, adviceY);

    // Section Titles
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("VITALS :", margin + 5, contentStartY + 1);
    doc.text("Complaint :", margin + 5, historyY + 15);
    doc.text("Instruction : ", margin + 5, adviceY + 15);

    // Rx Section
    doc.setFontSize(22);
    doc.setFont('times', 'bold');
    doc.text("Rx", leftSectionWidth + 15, contentStartY + 5);

    // ================= F. Vitals, Complaints, Inspections =================
   const leftColX = margin + 5;
const leftColWidth = leftSectionWidth - 10;
const itemFontSize = 8;
doc.setFontSize(itemFontSize);
doc.setFont('helvetica', 'normal');

// --- 1. Vitals Data ---
// Vitals ke data ko 'VITALS' heading ke neeche se start karenge.
let vitalsY = contentStartY + 15; // Starting Y for vitals list
if (formData.tests1 && formData.tests1.length > 0) {
    formData.tests1.forEach((item, idx) => {
        const vitalName = document.getElementById(`vital45${idx}`)?.selectedOptions[0]?.text || '';
        const vitalValue = document.getElementById(`vitalval45${idx}`)?.value || '';
        const text = `${idx + 1}. ${vitalName} ${vitalValue}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);
        
        // Check if it will overflow the section
        if (vitalsY + (wrappedText.length * (itemFontSize + 2)) < historyY) {
            doc.text(wrappedText, leftColX, vitalsY);
            vitalsY += wrappedText.length * (itemFontSize + 2);
        }
    });
}

// --- 2. Complaints Data ---
// Complaints ke data ko 'Complaint' heading ke neeche se start karenge.
let complaintsY = historyY + 30; // Starting Y for complaints list
if (formData.comps && formData.comps.length > 0) {
    formData.comps.forEach((item, idx) => {
        const compText = document.getElementById(`comp_txt${idx}`)?.value || '';
        const text = `${idx + 1}. ${compText}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);

        // Check if it will overflow the section
        if (complaintsY + (wrappedText.length * (itemFontSize + 2)) < adviceY) {
            doc.text(wrappedText, leftColX, complaintsY);
            complaintsY += wrappedText.length * (itemFontSize + 2);
        }
    });
}

// --- 3. Instructions Data ---
// Instructions ke data ko 'Instruction' heading ke neeche se start karenge.
// Aapne iske liye 'inspections' use kiya hai, maine wahi rakha hai.
let instructionsY = adviceY + 30; // Starting Y for instructions list
if (formData.inspections && formData.inspections.length > 0) {
    formData.inspections.forEach((item, idx) => {
        const inspText = document.getElementById(`insp_txt${idx}`)?.value || '';
        const text = `${idx + 1}. ${inspText}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);

        doc.text(wrappedText, leftColX, instructionsY);
        instructionsY += wrappedText.length * (itemFontSize + 2);
    });
}


// ================= E. Open PDF =================
const pdfBlobUrl = doc.output('bloburl');
window.open(pdfBlobUrl, '_blank');
};


const handlePrintPrescription = () => {
  const selectedDoctor = formData.docs.find(doc => doc.user_id === formData.opd_concult_doctor);
  const doctorDescription = selectedDoctor
    ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''} (${selectedDoctor.doc?.doc_degree || ''}, ${selectedDoctor.doc?.doc_specality || ''})`
    : 'N/A';
  const doctorRegNo = selectedDoctor ? selectedDoctor.doc?.doc_reg_number || selectedDoctor.doc?.doc_specality : selectedDoctor.doc?.doc_specality;
  
  // ✅ FIX: Get actual datetime
  const actualDateTime = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
  
  const timeStamp = Date.now();
  const dynamicBillNo = `${timeStamp}`;
  
  const parsedAge = parseAgeString(formData.opd_guardien_age);
  const doctorName = selectedDoctor ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim() : 'N/A';
  const doctorSpeciality = getSpecialityName(selectedDoctor?.doc?.doc_specality || selectedDoctor?.doc?.doc_speciality || '');
  const doctorDegree = (selectedDoctor?.doc?.doc_degree || '').trim();
  
  const presFormattedAge = formatAgeFromParts(
    formData.opd_guardien_years,
    formData.opd_guardien_months,
    formData.opd_guardien_days
  );
  const presAgeDisplay = presFormattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
  
  const prescriptionData = {
    config: { headerLogoUrl: headerLogo },
    patient: {
      uhid: formData.opd_uhid || 'N/A',
      name: `${formData.opd_patient_title || ''} ${formData.opd_patient_name || ''}`.trim(),
      address: formData.opd_address || 'N/A',
      age: presAgeDisplay,
      sex: formData.opd_patient_gender || 'N/A',
      mobile: formData.opd_patient_mobile || 'N/A'
    },
    bill: {
      opdNo: `000${formData.opd_id}`,
      date: formattedDateTime,  // ✅ Using formatted datetime
    },
    doctor: {
      name: doctorName,
      degree: doctorDegree,
      speciality: doctorSpeciality,
      regNo: (selectedDoctor?.doc?.doc_reg_number || selectedDoctor?.doc?.doc_reg_no || '') || 'N/A'
    }
  };

  generatePrescriptionPdf(prescriptionData);
};




    return (
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xxl-12">
              <h2 style={{ color: "#405189" }}>OPD Registration</h2>
              <br />
              <div class="live-preview">
                <form onSubmit={handleSubmit}>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <h5 style={{ color: "#405189" }}>Patient Details</h5>
                          <br />
                        </div>
                        <div
                          class={
                            formData.opd_type === "Old"
                              ? "col-md-2"
                              : "col-md-4"
                          }
                        >
                          <div>
                            <label for="productname-field" class="form-label">
                              OPD Type
                            </label>
                            <select
                              class="form-control"
                              data-trigger=""
                              name="opd_type"
                              onChange={handleChange}
                              value={formData.opd_type}
                              required
                            >
                              <option value="New Visit">New Visit</option>
                              <option value="Old">Old</option>
                            </select>

                            <input type="hidden" name="opd_token_no" value={formData.opd_token_no}/>
                          </div>
                        </div>
                        {formData.opd_type === "Old" ? (
                          <>
                          <div class="col-md-2">
                                                <div class="mb-3">
                                              <div className="mb-3 position-relative">
  <label className="form-label">UHID</label>
  <input
    type="text"
    className="form-control"
    placeholder="Enter UHID"
    name="lab_reg_uhid"
    value={formData.lab_reg_uhid}
    onChange={handleChange}
    onKeyUp={searchUserNow}
    autoComplete="off"
  />

  {uhidSuggestions.length > 0 && (
    <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
      {uhidSuggestions.map((user, idx) => (
        <li
          key={idx}
          className="list-group-item list-group-item-action"
          onClick={() => handleSelUser(user)}
          style={{ cursor: "pointer" }}
        >
          {user.lab_reg_uhid} - {user.lab_reg_name}
        </li>
      ))}
    </ul>
  )}
</div>


                                                </div>
                                            </div>
                                            {/* <div class="col-md-2">
                                                
                                                <button id="pop45" style={{ display: "none" }}
                                                    type="button" class="btn btn-success add-btn px-0"
                                                    data-bs-toggle="modal" data-bs-target="#usrModel" fdprocessedid="jys8hw"></button>
                                                <button id="searchbtn" onClick={() => {
                                                    searchUserNow()
                                                }} type="button" class="btn btn-success mt-4" style={{width: "180px"}}>
                                                    <i class="ri-search-line align-bottom me-1"></i> Search </button>
                                            </div> */}
                                            </>
                        ) : (
                          <></>
                        )}

                        <div class="col-md-4">
                          <div>
                            <label for="productname-field" class="form-label">
                              Patient Name
                            </label>
                            <div class="row">
                              <div class="col-md-4">
                                <select
                                  class="form-control"
                                  data-trigger=""
                                  name="opd_patient_title"
                                  onChange={handleChange}
                                  value={formData.opd_patient_title}
                                  required
                                >
                                  <option value="Mr.">Mr.</option>
                                  <option value="Mr's">Mr's</option>
                                  <option value="Miss">Miss</option>
                                  <option value="Master">Master</option>
                                </select>
                              </div>
                              <div class="col-md-8">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter Name"
                                  name="opd_patient_name"
                                  onChange={handleChange}
                                  value={formData.opd_patient_name}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div>
                            <label for="productname-field" class="form-label">
                              Gender
                            </label>
                            <input
                              class="form-control"
                              data-trigger=""
                              name="opd_patient_gender"
                              onChange={handleChange}
                              value={formData.opd_patient_gender}
                              required
                              readOnly
                              style={{ background: "#eeeeee" }}
                            >
                              
                            </input>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <br />
                        </div>
                        <div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Age</label>

    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      <input
        type="number"
        min="0"
        className="form-control"
        style={{ width: 120 }}
        placeholder="Years"
        value={ageYears}
        onChange={(e) => {
          const v = e.target.value === '' ? '' : String(Math.max(0, Number(e.target.value)));
          setAgeYears(v);
        }}
        required
      />

      <input
        type="number"
        min="0"
        max="11"
        className="form-control"
        style={{ width: 120 }}
        placeholder="Months"
        value={ageMonths}
        onChange={(e) => {
          const v = e.target.value === '' ? '' : String(Math.max(0, Math.min(11, Number(e.target.value))));
          setAgeMonths(v);
        }}
      />

      <input
        type="number"
        min="0"
        max="31"
        className="form-control"
        style={{ width: 120 }}
        placeholder="Days"
        value={ageDays}
        onChange={(e) => {
          const v = e.target.value === '' ? '' : String(Math.max(0, Math.min(31, Number(e.target.value))));
          setAgeDays(v);
        }}
      />
    </div>

    <div style={{ marginTop: 6, color: '#555', fontSize: 13 }}>
      { (ageYears || ageMonths || ageDays) ? 
         `${ageYears ? ageYears + 'Y' : ''} ${ageMonths ? ageMonths + 'M' : ''} ${ageDays ? ageDays + 'D' : ''}`.trim()
         : '0Y' }
    </div>
  </div>
</div>
                        <div class="col-md-4">
                          <div>
                            <label for="productname-field" class="form-label">
                              Guardian
                            </label>
                            <div class="row">
                              <div class="col-md-4">
                                <select
                                  class="form-control"
                                  data-trigger=""
                                  name="opd_guardien_title"
                                  onChange={handleChange}
                                  value={formData.opd_guardien_title}
                                  required
                                >
                                  <option value="C/O">C/O</option>
                                  <option value="S/O">S/O</option>
                                  <option value="D/O">D/O</option>
                                </select>
                              </div>
                              <div class="col-md-8">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter Name"
                                  name="opd_guardien_name"
                                  onChange={handleChange}
                                  value={formData.opd_guardien_name}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Address
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Address"
                              name="opd_address"
                              onChange={handleChange}
                              value={formData.opd_address}
                              required
                            />
                          </div>
                        </div> */}
                        {/* <div class="col-md-3">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              City
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter City"
                              name="opd_city"
                              onChange={handleChange}
                              value={formData.opd_city}
                              required
                            />
                          </div>
                        </div> */}

<div className="col-md-4" style={{ zIndex: 1100 }}>
  <label className="form-label">Speciality</label>
  <Select
    options={specialityOptions}
    value={specialityOptions.find(o => String(o.value) === String(formData.opd_specality)) || null}
    onChange={handleSpecSelect}
    placeholder="Select speciality..."
    isClearable
  />
</div>


<div className="col-md-4" style={{ zIndex: 1100 }}>
  <label className="form-label">Consultant Doctor</label>
  <Select
    options={doctorOptions}
    value={doctorOptions.find(o => String(o.value) === String(formData.opd_concult_doctor)) || null}
    onChange={handleDocSelect}
    placeholder="Select doctor..."
    isClearable
  />
</div>


                      

                        {/* Phone No */}
<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Phone No</label>
    <input
      type="text"
       min="0"
        max="10"
      className="form-control"
      name="opd_patient_mobile"
      placeholder="Enter Phone No"
      value={formData.opd_patient_mobile || ''}
      onChange={handleChange}
    />
  </div>
</div>
<div class="col-md-4" style={{marginTop: "-15px"}}>
                          <div class="mt-3">
                            <label for="firstNameinput" class="form-label">
                              Registration Date
                            </label>
                            <input
  type="date"
  class="form-control"
  placeholder=""
  name="opd_datetime_display"
  onChange={(e) => {
    const dateValue = e.target.value;
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const fullDateTime = `${dateValue} ${hours}:${minutes}:${seconds}`;
    
    setFormData(prev => ({
      ...prev,
      opd_datetime: fullDateTime,
      opd_datetime_display: dateValue
    }));
  }}
  value={formData.opd_datetime_display || (formData.opd_datetime ? formData.opd_datetime.split(' ')[0] : '')}
  required
  readOnly
  style={{ background: "#eeeeee" }}
/>
                          </div>
                        </div>
{/* Address */}
<div className="col-md-12">
  <div className="mb-3">
    <label className="form-label">Address</label>
    <textarea
      rows={2}
      className="form-control"
      name="opd_address"
      placeholder="Enter Address"
      value={formData.opd_address || ''}
      onChange={handleChange}
    />
  </div>
</div>

                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <h5 style={{ color: "#405189" }}>Payment Details</h5>
                          <br />
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Total Amount
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Total Amount"
                              name="opd_total"
                              onChange={handleChange}
                             value={formData.opd_concult_doctor ? (formData.opd_total ?? 0) : formData.opd_reg_fees}

                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              OPD Fees
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter OPD Fees"
                              name="opd_fees"
                              onChange={handleChange}
                         value={Number(formData.opd_fees) || 0}



                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Registration Fees
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Registration Fees"
                              name="opd_reg_fees"
                              onChange={handleChange}
                              value={formData.opd_reg_fees}
                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Discount(%)
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Discount(%)"
                              name="opd_discount"
                              onChange={handleChange}
                              value={formData.opd_discount}
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Final Amount
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Final Amount"
                              name="opd_final_amt"
                              onChange={handleChange}
                              value=
                              {formData.opd_concult_doctor ? (formData.opd_final_amt ?? 0) : formData.opd_reg_fees}
                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Paid
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Paid"
                              name="opd_paid"
                              onChange={handleChange}
                              value={formData.opd_paid}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label htmlFor="paymentMode" className="form-label">
                              Payment Mode
                            </label>
                            <select
                              className="form-control"
                              name="opd_mode"
                              onChange={handleChange}
                              value={formData.opd_mode}
                              required
                            >
                              <option value="">Select Payment Mode</option>
                              <option value="Cash">Cash</option>
                              <option value="Online">Online</option>
                              <option value="Card">Card</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Remarks
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Remarks"
                              name="opd_remark"
                              onChange={handleChange}
                              value={formData.opd_remark}
                              
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Due
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Due"
                              name="opd_due"
                              onChange={handleChange}
                              value=
                              {formData.opd_concult_doctor ? (formData.opd_due ?? 0) : formData.opd_reg_fees}
                              required
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 <div className="col-lg-12">
  <div className="card bg-light shadow-sm p-3 mb-3">
    <div className="text-end">
      <button
        type="button"
        className="btn btn-outline-primary d-inline-flex align-items-center"
        onClick={() => setShowOtherDetails(!showOtherDetails)}
      >
        {showOtherDetails ? (
          <i className="ri-arrow-up-s-line me-1 align-middle"></i>
        ) : (
          <i className="ri-arrow-down-s-line me-1 align-middle"></i>
        )}
        {showOtherDetails ? "Hide Details" : "More Details"}
      </button>
    </div>
  </div>
</div>


                 {showOtherDetails && (
                    <>
                    <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <h5 style={{ color: "#405189" }}>Other Details</h5>
                          <br />
                        </div>
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h6>Vital Details</h6>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFormData((prev) => ({
                                    ...prev,
                                    tests1: [
                                      ...prev.tests1,
                                      {
                                        sn: prev.tests1.length + 1,
                                        opd_val_name: "",
                                        opd_val_value: "",
                                      },
                                    ],
                                  }));
                                }}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th data-sort="id">S. No.</th>
                                      <th data-sort="customer_name">
                                        Vital Name
                                      </th>
                                      <th data-sort="city">Value</th>
                                      <th data-sort="city">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.tests1.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="product_name">
                                          <select
                                            className="form-control"
                                            data-trigger=""
                                            id={"vital45" + index}
                                          >
                                            {formData.vitals.map(
                                              (vital, idx) => (
                                                <option
                                                  key={idx}
                                                  value={vital.cat_id}
                                                >
                                                  {vital.cat_name}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </td>
                                        <td className="date">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id={"vitalval45" + index}
                                          />
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  const tmp = [
                                                    ...formData.tests1,
                                                  ];
                                                  tmp.splice(index, 1);
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    tests1: tmp,
                                                  }));
                                                }}
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

               
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h5 style={{ color: "#405189" }}>Complaints</h5>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={addComplaint}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th
                                        data-sort="id"
                                        style={{ width: "60px" }}
                                      >
                                        S. No.
                                      </th>
                                      <th data-sort="customer_name">
                                        Complaint Name
                                      </th>
                                      <th
                                        data-sort="city"
                                        style={{ width: "100px" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.comps.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="date">
                                          <textarea
                                            className="form-control"
                                            id={`comp_txt${index}`}
                                            rows="3"
                                          ></textarea>
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  removeComplaint(index)
                                                }
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h5 style={{ color: "#405189" }}>Instruction</h5>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={addInspection}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th
                                        data-sort="id"
                                        style={{ width: "60px" }}
                                      >
                                        S. No.
                                      </th>
                                      <th data-sort="customer_name">
                                        Instruction Name
                                      </th>
                                      <th
                                        data-sort="city"
                                        style={{ width: "100px" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.inspections.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="date">
                                          <textarea
                                            className="form-control"
                                            id={`insp_txt${index}`}
                                            rows="3"
                                          ></textarea>
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  removeInspection(index)
                                                }
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                  </> 
                 )}
                   <div className="card">
                          <div className="card-body">
                            <div className="row">
                              {/* Submit Buttons */}
                              <div className="col-lg-12">
                                <div className="text-end">
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Save
                                  </button>
                                  &nbsp;&nbsp;&nbsp;


                                  <button
  type="button"
  className="btn btn-success"
  disabled={!isSaved || !formData.opd_uhid}
  onClick={() =>
    printThermalBarcodeIframe(
      `${formData.opd_patient_title || ""} ${formData.opd_patient_name || ""}`.trim(),
      // Use formatted age display (prefer numeric parts if present)
      (formatAgeFromParts(formData.opd_guardien_years, formData.opd_guardien_months, formData.opd_guardien_days) || formData.opd_guardien_age || 'N/A'),
      formData.opd_uhid
    )
  }
>
  Print Barcode
</button>

<canvas ref={barcodeCanvasRef} style={{ display: 'none' }} />
&nbsp;&nbsp;&nbsp;
                                  <button
                                    type="button"
                                    className="btn btn-dark"
                                      disabled={!formData.opd_uhid || !isFormValid()}
                                      onClick={handlePrint}
                                     
                                    >
                                   
                                    Print Receipt
                                  </button>
                                  &nbsp;&nbsp;&nbsp;
                                  <button
                                    type="button"
                                    className="btn btn-info "
                                    onClick={handlePrintPrescription}
                                    disabled={
                                      !isSaved ||
                                      !formData.opd_uhid ||
                                      parseFloat(formData.opd_due || 0) !== 0 ||
                                      // ensure current paid matches saved paid (prevents typing paid without save)
                                      parseFloat(String(formData.opd_paid || 0)) !== parseFloat(String(lastSavedPaid || 0))
                                    }
                                  >
                                    Print Prescription 
                                  </button>
                                  &nbsp;&nbsp;&nbsp;
                                   <a href="/opd_patient_list" class="btn btn-danger">Cancel</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default OpdRegistrations;
